import Axios from 'axios'
import {
	ICancelMissingOrdersParams,
	IConfirmMissingOrdersParams,
	IConfirmMissingOrdersStatusParams,
	IGetActivationMissingOrdersParams,
	ISelectActivationMissingItemParams
} from 'models/ActivationMissingOrders'
const urlBase = 'p_vta_act_faltas'

export const getActivationMissingOrdersApi = async (
	params: IGetActivationMissingOrdersParams
) => {
	const response = await Axios.get(`${urlBase}/consulta`, { params })
	return response.data
}

export const selectActivationMissingItemApi = async (
	params: ISelectActivationMissingItemParams
) => {
	const response = await Axios.post(`${urlBase}/validar`, params)
	return response.data
}

export const confirmActivationMissingOrdersApi = async (
	params: IConfirmMissingOrdersParams
) => {
	const response = await Axios.post(`${urlBase}/confirmar`, params)
	return response.data
}

export const confirmActivationMissingStatusApi = async (
	params: IConfirmMissingOrdersStatusParams
) => {
	const response = await Axios.get(`${urlBase}/estado`, { params })
	return response.data
}

export const cancelActivationMissingOrdersApi = async (
	params: ICancelMissingOrdersParams
) => {
	const response = await Axios.post(`${urlBase}/cancelar`, params)
	return response.data
}
